import { find, get } from "lodash";
import moment from "moment";
import React, { Component } from "react";
import Loadable from "react-loadable";
import { connect } from "react-redux";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { partnerInfo } from "~/configs/partnerDetails";
import history from "~/history";
import {
  clearState,
  resetStatusScanQrCodeInsurance
} from "~/store/patient/patientAction";
import {
  checkRequirePayment,
  resetPaymentMethod
} from "~/store/payment/paymentAction";
import {
  changeDirection,
  getBookingTree,
  getExtraConfig,
  removeSchedule,
  reserveBookingPartner
} from "~/store/totalData/actions";
import { MOMO } from "~/utils/constants";
import { getPartnerFromUrl, routerByPartnerId } from "~/utils/func";
import AppId from "~/utils/partner";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const TrustInformationPageDesktop = Loadable({
  loader: () => import("~/components/desktop/pages/TrustInformation"),
  loading: LoadableLoading
});

class DetectTrustInformation extends Component {
  componentDidMount() {
    const {
      resetStatusScanQrCodeInsurance,
      getBookingTree,
      schedulesSelected,
      resetPaymentMethod,
      getExtraConfig
    } = this.props;

    resetPaymentMethod();

    getExtraConfig();

    if (schedulesSelected.length === 0) {
      const currentPagePartnerId = getPartnerFromUrl(
        this.props.history.location.pathname
      );
      getBookingTree("", currentPagePartnerId);
    }
    resetStatusScanQrCodeInsurance();
  }

  methods = {
    handleNextStep: () => {
      const { reserveBookingPartner } = this.props;
      if (AppId === MOMO) {
        reserveBookingPartner();
      } else {
        this.props.checkRequirePayment();
      }
    },

    handleGoBack: () => {
      const {
        isRepayment,
        changeDirection,
        // clearState,
        schedulesSelected,
        partnerId,
        removeSchedule
      } = this.props;
      let route = "";
      if (schedulesSelected.length > 1) {
        removeSchedule(-1);
        route = routerByPartnerId("/chon-chuyen-khoa", partnerId);
      } else if (isRepayment) {
        route = "/user";
      } else {
        route = "/chon-lich-kham";
        // clearState();
      }
      changeDirection();
      this.props.history.push({
        pathname: route,
        state: { activeItem: 2 }
      });
    }
  };

  render() {
    const { schedulesSelected } = this.props;

    if (schedulesSelected.length === 0) {
      const { partnerId, getBookingTree } = this.props;
      const route = routerByPartnerId("/chon-chuyen-khoa", partnerId);
      history.push(route);
      getBookingTree("", partnerId);
    }

    return (
      <React.Fragment>
        <TrustInformationPageDesktop {...this.props} {...this.methods} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    user: { IsAuthenticated },
    doctorAndTime: { alertMaxSpecialist },
    dateAndSpecialist: { selectedSpecialist },
    totalData: {
      schedulesSelected,
      bookingTree,
      room,
      hospitalSelected,
      isRepayment,
      partnerId,
      subject: { isHasSubject },
      service: { isHasService },
      room: { isHasRoom },
      doctor: { isHasDoctor },
      extraConfig
    },
    hospital: { selectedHospital }
  } = state;
  const selectedDate = moment(state.dateAndSpecialist.selectedDate).format(
    "DD-MM-YYYY"
  );
  return {
    IsAuthenticated,
    device: type,
    alertMaxSpecialist,
    selectedSpecialist,
    selectedDate,
    schedulesSelected,
    bookingTree,
    room,
    hospitalSelected,
    isRepayment,
    partnerId,
    selectedHospital,
    isHasSubject,
    isHasService,
    isHasRoom,
    isHasDoctor,
    extraConfig
  };
};

const TrustInformationHelmet = withTitle({
  component: DetectTrustInformation,
  title: `${hospitalName.value} | Xác nhận thông tin đặt khám`
});

export default connect(mapStateToProps, {
  getExtraConfig,
  changeDirection,
  resetStatusScanQrCodeInsurance,
  reserveBookingPartner,
  getBookingTree,
  checkRequirePayment,
  resetPaymentMethod,
  removeSchedule,
  clearState: clearState
})(TrustInformationHelmet);
